"use client";

import ToolCaseSvg from "../../assets/animations/tool-case.animated.svg";
import { SvgAnimation, type SvgAnimationProps } from "../svg-animation/svg-animation";

export function ToolCaseAnimation(props: SvgAnimationProps) {
  return <SvgAnimation {...props} svg={ToolCaseSvg} />;
}
